var cartPromo = {
    campaigns: [],
    promoLoaded: false,

    init: function () {
        if(typeof window.cartPromoCampaigns === 'object'){
            this.campaigns = window.cartPromoCampaigns;
        }
        this.checkCart();
    },

    checkCart: function(){
        var self = this;
        $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function(cart) {
                self.updateCartTagsScript();
                if(cart.total_price > 0){
                    self.checkPromos(cart);
                } else if(cart.total_price == 0 && cart.item_count>0){
                    self.clearCart();
                } else {
                    self.refreshCart(cart);
                }
            }
        });
    },

    checkPromos: function(cart){

        var cartItems = cart.items,
            promos = [],
            self = this;

        if(this.campaigns.length == 0) return;

        for(i in this.campaigns){
            var campaign = this.campaigns[i];
            var ret = self.matchCampaignInCart(cartItems,cart,campaign);

            // Overwrite tmpCartItems with updated quantity in order to check other campaigns
            cartItems = ret.cartItems;

            // Update promos with campaign promo
            if(ret.promo != null){
                promos.push(ret.promo);
            }
        }


        if(promos.length > 0){
            this.applyPromos(promos);
        }
    },

    resetPromos: function(){

        if(this.campaigns.length > 0){

            var resetArray = [];
            for(i in this.campaigns){
                var promo = this.campaigns[i].promo;
                resetArray.push(promo);
            }

            this.applyPromos(resetArray,true);
        }
    },

    applyPromos: function (promos, reset) {

        reset = (typeof reset !== 'undefined') ? true :  false;

        var self = this,
            promosToApply = {};

        if(promos.length > 0 && typeof promos === 'object'){

            // Let' aggregate same promo items

            // Cycle all promos
            for(i in promos){

                // Cycle products for each promo
                for(k in promos[i]){
                    var p = promos[i][k],
                        pQty = (typeof(promosToApply[p.id]) === 'undefined') ? 0 : promosToApply[p.id];

                    // Reset promo products in cart
                    promosToApply[p.id] = reset ? 0 : pQty + p.quantity;
                }
            }



            $.ajax({
                url: '/cart/update.js',
                dataType: "json",
                cache: false,
                data: {
                    updates: promosToApply
                },
                success: function(cart) {
                    self.refreshCart(cart);
                }
            });

        }

    },



    matchCampaignInCart: function(cartItems,cart,campaign){

        var promo = null,
            itemsMatch = [],
            tagsMatch = [],
            campaignAdjustQuantities = [],
            self = this;

        // Check all campaign product tags to match in cart
        tagsMatch = self.checkPromoTags(cart,campaign);
        var tags_match_campaign = campaign.products_match_logic === "and" ? (tagsMatch.indexOf(false) === -1) : (tagsMatch.indexOf(true) !== -1);

        // Cycle all campaign products to match in cart
        for(k in campaign.prods){
            var cProd = campaign.prods[k],
                cProdFound = false;

            // Cycle all cart items
            for(i in cartItems){
                var item = cartItems[i];

                // We found a matching cart item and cart total
                if(
                    (cProd.id == item.id || cProd.id == '*')  &&
                    cart.total_price >= (campaign.total_price*100)){
                    // We check quantity of the matching item
                    if(item.quantity >= cProd.quantity){

                        cProdFound = true;
                        // cartItems[i].quantity = cartItems[i].quantity - cProd.quantity;
                        // We store the quantity we will eventually subtract from tmp cart availability for other promos checks
                        campaignAdjustQuantities[i] = item.quantity - cProd.quantity;

                    }
                }
            }

            itemsMatch.push(cProdFound);
        }

        var products_match_campaign = campaign.products_match_logic === "and" ? (itemsMatch.indexOf(false) === -1) : (itemsMatch.indexOf(true) !== -1);

        var global_match_campaign = false;

        // if we have products as qualifiers
        if(campaign.prods.length > 0) global_match_campaign = products_match_campaign;

        if (campaign.tags.length > 0){

            if(campaign.prods.length > 0){
                // if we have ALSO tags as qualifiers
                global_match_campaign = (products_match_campaign && tags_match_campaign);
            } else {
                // if we have ONLY tags as qualifiers
                global_match_campaign = tags_match_campaign;
            }
        }
        // Cart matches all campaing requirements
        if(global_match_campaign && !self.isVirtualCart(cart)){

            // Adjust the tmp cart quantity of the product cause these item have already been used to trigger this promo
            // and will not considered for other promos
            for(i in cartItems){
                if(typeof campaignAdjustQuantities[i] === 'number') cartItems[i].quantity = campaignAdjustQuantities[i];
            }

            promo = campaign.promo;

        } else {

            // Otherwise we must reset eventually active campaign
            var tmp = [];
            for(kk in campaign.promo){
                tmp[kk] = {
                    id : campaign.promo[kk].id,
                    quantity: 0
                }
            }

            promo = tmp;
        }

        return {cartItems: cartItems, promo: promo};
    },

    checkPromoTags: function(cart,campaign) {
        var ret = [];
        for ( t in campaign.tags ){
            if ( campaign.tags_match_logic === 'include' ){
                // Include tags logic (tags must be present in cart in order to match campaign)
                if ( typeof cartTags[campaign.tags[t].idTag] != 'undefined' ) {
                    if ( cartTags[campaign.tags[t].idTag] >= campaign.tags[t].quantity && cart.total_price >= (campaign.total_price*100)) {
                        ret.push(true);
                    } else {
                        ret.push(false);
                    }
                } else {
                    ret.push(false);
                }
            } else {
                // Exclude tags logic (tags must be present in cart in order to match campaign)
                if ( typeof cartTags[campaign.tags[t].idTag] != 'undefined' ) {
                    if ( cartTags[campaign.tags[t].idTag] >= campaign.tags[t].quantity) {
                        // if we find the product tags and quantity the campaign will fail
                        ret.push(false);
                    } else {
                        // otherwise we check the cart total
                        ret.push(cart.total_price >= (campaign.total_price*100));
                    }
                } else {
                    // if we don't find the product tags in cart the campaing will success
                    ret.push(true);
                }
            }
        }

        return ret;
    },

    clearCart: function(){
        var self = this;
        $.ajax({
            url: '/cart/clear.js',
            dataType: "json",
            cache: false,
            success: function(cart) {
                self.refreshCart(cart);
            }
        });
    },

    checkFreeMini: function(cart){

        var check = [];
        for(i in cart.items){
            item = cart.items[i];
            if(this.freeMini.indexOf(item.id) !== -1){
                check.push(item.id);
            }
        }
        return check;
    },

    isVirtualCart: function(cart) { //check if all products in cart are virtual
        var self = this;
        for(i in cart.items) {
            item = cart.items[i];
            if(item.requires_shipping == true && item.product_type != 'promogift' && item.product_type != 'sachet') {
                return false;
            }
        }
        return true;
    },

    refreshCart: function(cart){
        this.promoLoaded = true;
        window.refreshCart(cart);
        this.promoLoaded = false;
    },
    updateCartTagsScript: function(){
        $.ajax({
            url: '/?section_id=cart-promo-tag-scripts',
            async: false,
            dataType: "html",
            cache: false,
            success: function(html) {
                const scriptContent = $(html).find('#updateCartTagsScript').html();
                eval(scriptContent);
            }
        });
    }
}

cartPromo.init();